import {apiRequest} from "../action/api.action"
import { FETCH_FLEETS_DATA, FETCH_FLEETS_FAILURE, FETCH_FLEETS_SUCCESS, UPDATE_FLEET_FOR_MAP, ADD_VESSEL_TO_FLEET, ADD_VESSEL_TO_FLEET_SUCCESS, ADD_VESSEL_TO_FLEET_FAILURE, fetchFleetsData, REMOVE_VESSEL_FROM_FLEET, REMOVE_VESSEL_FROM_FLEET_FAILURE, REMOVE_VESSEL_FROM_FLEET_SUCCESS, ADD_SHIPYARD_TO_WATCHLIST, ADD_SHIPYARD_TO_WATCHLIST_SUCCESS, ADD_SHIPYARD_TO_WATCHLIST_FAILURE, REMOVE_SHIPYARD_FROM_WATCHLIST_SUCCESS, REMOVE_SHIPYARD_FROM_WATCHLIST_FAILURE, REMOVE_SHIPYARD_FROM_WATCHLIST } from "../action/fleet.action";
import { FETCH_MAP_DATA_SUCCESS, FETCH_MAP_DATA_FAILURE } from "../action/map-data.action";
import {dismiss, update, error, message, warning, success, info} from 'react-toastify-redux';

export const fleetFlow = ({dispatch}) => next => action => {

  next(action)
  
  if(action.type === FETCH_FLEETS_DATA) {
    let url = `/api/v1/fleet/`;
    dispatch(apiRequest('GET', url, null, FETCH_FLEETS_SUCCESS, FETCH_FLEETS_FAILURE));
  } else if (action.type === UPDATE_FLEET_FOR_MAP) {
    let fleetIds = action.payload.join(",")
    let url = `/api/v1/business-generator/vessels-watchlist?fleetIds=${fleetIds}`;
    dispatch(apiRequest('GET', url, null, FETCH_MAP_DATA_SUCCESS, FETCH_MAP_DATA_FAILURE));
  } else if (action.type === ADD_VESSEL_TO_FLEET) {
    let url = `/api/v1/fleet/add-vessel-to-fleet`;
    dispatch(apiRequest('POST', url, action.payload, ADD_VESSEL_TO_FLEET_SUCCESS, ADD_VESSEL_TO_FLEET_FAILURE));
  } else if (action.type === REMOVE_VESSEL_FROM_FLEET) {
    let url = `/api/v1/fleet/remove-vessel-from-fleet/${action.payload.fleetId}/${action.payload.myVesselId}`;
    dispatch(apiRequest('DELETE', url, null, REMOVE_VESSEL_FROM_FLEET_SUCCESS, REMOVE_VESSEL_FROM_FLEET_FAILURE));
  } else if (action.type === ADD_VESSEL_TO_FLEET_SUCCESS) {
    dispatch(success("Add vessel to fleet successed."))
    dispatch(fetchFleetsData());
  } else if (action.type === ADD_SHIPYARD_TO_WATCHLIST){
    let url = `/api/v1/shipyards/add-to-watchlist/${action.payload.shipyardId}`;
    dispatch(apiRequest('POST', url, null, ADD_SHIPYARD_TO_WATCHLIST_SUCCESS, ADD_SHIPYARD_TO_WATCHLIST_FAILURE));
  } else if (action.type === REMOVE_SHIPYARD_FROM_WATCHLIST){
    let url = `/api/v1/shipyards/remove-from-watchlist/${action.payload.shipyardId}`;
    dispatch(apiRequest('DELETE', url, null, REMOVE_SHIPYARD_FROM_WATCHLIST_SUCCESS, REMOVE_SHIPYARD_FROM_WATCHLIST_FAILURE));
  } else if (action.type === ADD_SHIPYARD_TO_WATCHLIST_SUCCESS) {
    dispatch(success("Add shipyard to watch list successed."))
  } else if (action.type === REMOVE_VESSEL_FROM_FLEET_SUCCESS) {
    dispatch(success("Remove vessel from fleet successed."))
  } else if (action.type === REMOVE_SHIPYARD_FROM_WATCHLIST_SUCCESS) {
    dispatch(success("Remove shipyard from watch list successed."))
  }
};

export const fleetMdl = [fleetFlow];